import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, CustomEase);

// Easing
CustomEase.create('headingEasing', '0, 0, 0, 1');
CustomEase.create('smoothEasing', '0.5, 0, 0, 1');
CustomEase.create('buttonEasing', '0, 0, 0, 1');
CustomEase.create('shapeEasing', '0.8, 0, 0.2, 1');
CustomEase.create('imageEasing', '0.74, 0, 0.26, 1');
CustomEase.create('slowDown', '0, 0, 0.14, 1');
CustomEase.create('naturalEasing', '0.62, 0, 0.38, 1');
CustomEase.create('accelerateEasing', '1, 0, 1, 1');
CustomEase.create('accelerateButton', '0.82, 0, 1, 1');
CustomEase.create('slowDownButton', '0, 0, 0.18, 1');

export const animateHeroElement = (elementClass, from = {}, to = {}) => {
	const element = document.querySelector(elementClass);

	if (!element) return;

	gsap.fromTo(
		element,
		{
			opacity: 1,
			...from,
		},
		{
			...to,
		}
	);
};

export const animateShape = (shapeClass, to = {}, isBottom = false) => {
	if (!shapeClass) return;

	gsap.fromTo(
		shapeClass,
		{ rotate: 0 },
		{
			duration: 1.8,
			ease: 'shapeEasing',
			scrollTrigger: {
				trigger: shapeClass,
				start: isBottom ? 'top 60%' : 'top 40%',
				end: 'bottom 20%',
				toggleActions: 'play none none',
			},
			stagger: {
				amount: 0.2,
				each: 0.1,
			},
			...to,
		}
	);
};
